import gql from 'graphql-tag';
import FieldsCreditBundle from 'graphql/fields/FieldsCreditBundle';

export default gql(`
	query credit_bundles( $timeslot_kind_guid: String, $status: [String] ) {
		credit_bundles( timeslot_kind_guid: $timeslot_kind_guid, status: $status ) {
			${FieldsCreditBundle}

			timeslot_kind {
				guid
			}
		}
	}
`);

